/**
 * @deprecated use it from @grafana/data. Kept here for backward compatibility.
 */
export enum NodeGraphDataFrameFieldNames {
  id = 'id',
  title = 'title',
  subTitle = 'subTitle',
  mainStat = 'mainStat',
  secondaryStat = 'secondaryStat',
  source = 'source',
  target = 'target',
  detail = 'detail__',
  arc = 'arc__',
  color = 'color',
}
